import { MARK_LINE_BREAK, Size, markReasonLines } from '@bms2/shared';
import { IconButton } from '../controls/IconButton';
import { suggestionDotFor, type DotSubject } from './SuggestionDot';
import styles from './ListRowMarks.module.css';

/** The row fields a Marks cell reads: the gold dot's flag, and the failed checks' lines and tile the server wrote. */
export interface MarkedRow {
  hasSuggestions?: unknown;
  markReasons?: unknown;
  markTile?: unknown;
}

/**
 * 🔒 A list row's Marks cell (piece 13; decisions 9720, 10070; T3164, T3457): the gold suggestions dot of T3028, then
 * one warning triangle where the record or any record under it fails a check. The triangle's title, the shared icon
 * button's own tooltip, reads one line per failing record, naming it and why; pressing it opens the record at the tile
 * its first line names. 🔨 It reads the row's own fields and looks nothing up; what fails, and how it climbs the record
 * tree, is the server's.
 */
export function ListRowMarks({ row, subject, onOpenTile }: { row: MarkedRow; subject: DotSubject; onOpenTile?: (tile: string) => void }) {
  const lines = markReasonLines(row.markReasons);
  const tile = typeof row.markTile === 'string' ? row.markTile : null;
  const dot = suggestionDotFor(row.hasSuggestions, subject);
  if (!dot && lines.length === 0) return null;
  return (
    <span className={styles.marks} data-row-marks="true">
      {dot}
      {lines.length > 0 ? (
        <span className={styles.triangle} data-row-mark="failedCheck" data-row-mark-lines={lines.length} onClick={(event) => event.stopPropagation()}>
          <IconButton meaning="warning" label={lines.join(MARK_LINE_BREAK)} size={Size.Small} tone="warning" name="row-mark-failedCheck" onClick={() => { if (tile) onOpenTile?.(tile); }} />
        </span>
      ) : null}
    </span>
  );
}
